export { LockMessageComponent } from './LockMessageComponent';
